"use strict";

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.get = void 0;

const fingerprintjs_1 = __importDefault(require("@fingerprintjs/fingerprintjs"));

const externalComponents_1 = require("../utils/externalComponents");

const hashCanvasValue_1 = require("../utils/hashCanvasValue");

const parseValueToString_1 = require("../utils/parseValueToString");

const get = () => __awaiter(void 0, void 0, void 0, function* () {
  var _a, _b;

  let components = {};

  try {
    const fp = yield fingerprintjs_1.default.load({
      debug: false,
      monitoring: false
    });
    const result = yield fp.get(); // 处理canvas

    if ((_b = (_a = result === null || result === void 0 ? void 0 : result.components) === null || _a === void 0 ? void 0 : _a.canvas) === null || _b === void 0 ? void 0 : _b.value) {
      result.components.canvas.value = (0, hashCanvasValue_1.hashCanvasValue)(result.components.canvas.value);
    } // 拓展的指纹信息


    const externalComponents = (yield (0, externalComponents_1.getExternalComponents)()) || {};
    const combine = Object.assign(Object.assign({}, (result === null || result === void 0 ? void 0 : result.components) || {}), externalComponents);
    components = (0, parseValueToString_1.stringifyComponents)(combine);
  } finally {
    return components;
  }
});

exports.get = get;